class BattleshipChange {
    changeIndex;
    functionId;
    weekDayId;
    timeIn;
    roomId: number | null;
    instructorId: number | null;

    constructor(changeIndex: number, functionId: number, weekDayId: number, timeIn: string, roomId: number | null, instructorId: number | null) {
        this.changeIndex = changeIndex;
        this.functionId = functionId;
        this.weekDayId = weekDayId;
        this.timeIn = timeIn;
        this.roomId = roomId;
        this.instructorId = instructorId;
    }
}

export default BattleshipChange;